import Vue from 'vue'
import rolebleMixin from '@/mixins/rolebleMixin'
import ChatRoom from '@/models-ts/chat/ChatRoom'
import JobMarkedDoneChatMessage from '@/models-ts/chat/messages/JobMarkedDoneChatMessage'
import messageMixin from '../messageMixin'

export default Vue.extend<any, any, any, any>({
  mixins: [messageMixin, rolebleMixin],
  props: {
    message: JobMarkedDoneChatMessage,
    room: ChatRoom,
  },
  computed: {
    msg() {
      if (this.message.isPayed) {
        if (this.isOwn) {
          return `Good job! Customer confirmed that Job is done. Please rate this Job.`
        } else {
          return `Good job! You confirmed that Job is done. Please rate this Job.`
        }
      } else if (this.message.markIsDone) {
        if (this.isOwn) {
          return `After successful confirming review by customer you'll receive your reward`
        } else {
          return `Talent marked Job as complete.`
        }
      } else {
        const declinedFreelancer = this.message.sender === this.message.initiator
        if (this.isOwn) {
          return `${declinedFreelancer ? 'You' : 'Customer'} declined Job's completion.`
        } else {
          return `${declinedFreelancer ? 'Talent' : 'You'} declined Job's completion`
        }
      }
    },
  },
})
